import ProviderOrdersLayout from "./ProviderOrdersLayout";
import ProviderProductOrders from "./ProviderProductOrders";

export default function ProviderOrdersProducts() {
  return (
    <ProviderOrdersLayout>
      <ProviderProductOrders />
    </ProviderOrdersLayout>
  );
}
